import React from 'react';
import styled from 'styled-components';
import { PlayCircle, PauseCircle } from 'react-feather';
import { usePlayer, style } from '../../../../api';

import Box, { BoxProps } from '../../Box';
import {
  usePlayerState,
  usePlayerControls,
} from '../../../Player/PlayerContext';

const BoxHover = styled(Box)`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px;
`;

interface PlayButtonProps {
  local?: boolean;
  playTrack?: (trackId: number) => void;
  trackId?: number;
}

const RoundPlayButton = ({
  trackId,
  local,
  playTrack,
  ...props
}: BoxProps & PlayButtonProps) => {
  const player = usePlayer();

  const playerState = usePlayerState();
  const controls = usePlayerControls();

  const playing =
    trackId && !local
      ? trackId === player.track?.id && !playerState?.paused
      : !playerState?.paused;

  const togglePauseTrack = () => {
    if (local || !trackId || trackId === player.track?.id) {
      controls?.toggle();
    } else if (playTrack) {
      playTrack(trackId);
    } else {
      player.playTrackById(trackId);
    }
  };
  return (
    <BoxHover {...props} onClick={togglePauseTrack}>
      {playing ? (
        <PauseCircle
          size="100%"
          fontSize="10"
          strokeWidth={1}
          fill={style.primary_pink_new}
        />
      ) : (
        <PlayCircle
          size="100%"
          fontSize="10"
          strokeWidth={1}
          fill={style.primary_pink_new}
        />
      )}
    </BoxHover>
  );
};

export default RoundPlayButton;
